import { defineStore } from "pinia";
import session from "@/services/session.js";

export const useSessionStore = defineStore("session", {
  state: () => ({
    csrfToken: "",
    usuarioId: null,
    nombre: "",
    esAdmin: false,
    esPartner: false,
    esResponsable: false,
    mostrarBannerDePruebas: false,
    ultimaOfertaModificada: null,
    tema: "esginnova",
  }),
  getters: {
    loggedIn() {
      return this.usuarioId > 0;
    },
    esKantan() {
      return this.tema == "kantan";
    },
  },
  actions: {
    setSession(currentSession) {
      this.$patch({
        csrfToken: String(currentSession.csrfToken),
        nombre: String(currentSession.nombre),
        usuarioId: Number(currentSession.usuarioId),
        esAdmin: Boolean(currentSession.esAdmin),
        esPartner: Boolean(currentSession.esPartner),
        esResponsable: Boolean(currentSession.esResponsable),
        mostrarBannerDePruebas: Boolean(currentSession.mostrarBannerDePruebas),
        tema: String(currentSession.tema),
      });
    },
    setUltimaOfertaModificada(id) {
      this.ultimaOfertaModificada = id;
    },
    async login(email, clave) {
      const currentSession = await session.login(email, clave);
      this.setSession(currentSession);
    },
    async logout() {
      await session.logout();
      this.$reset();
    },
    async recover() {
      const currentSession = await session.recover();
      this.setSession(currentSession);
    },
  },
});
